import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-257" data-mp="3mg0pyy0ehdko">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-258" data-mp="3r8tt5hg80dun" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-label="Testimonials" data-id="element-259" data-mp="421gir28q6aw">
      <div className="mx-auto max-w-5xl" data-id="element-260" data-mp="91e5bhco9ng4">
        <SectionHeading title={<>What other professionals are saying</>} data-id="element-261" data-mp="92fipsh5um10" />
        <div className="-mt-4 mb-10 flex items-center justify-center gap-3" data-id="element-262" data-mp="dzxstm6wz7al">
          <span className="font-serif text-4xl font-bold text-ink" data-id="element-263" data-mp="2atsik349u3q7">4.9/5</span>
          <Stars data-id="element-264" data-mp="2fsc6ua6c7rlq" />
        </div>

        <div className="grid gap-5 md:grid-cols-2" data-id="element-265" data-mp="2frkcf2oh7zx1">
          {testimonials.map((t, i) => <figure key={t.name} className={`flex flex-col rounded-2xl bg-cream p-6 ring-1 ring-navy/5 ${i === testimonials.length - 1 ? "md:col-span-2 md:mx-auto md:max-w-[calc(50%-0.625rem)]" : ""}`} data-id="element-266" data-mp="1sksu3zqrn6qn" data-mpi={i}>
              <QuoteIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-267" data-mp="1iuzmtaxnpds7" />
              <blockquote className="mt-3" data-id="element-268" data-mp="1eufklsy87jz7">
                <p className="font-serif text-xl font-bold leading-snug text-ink" data-id="element-269" data-mp="2bjevlfq72zv3">“{t.headline}”</p>
                <p className="mt-2 text-base leading-relaxed text-ink/75" data-id="element-270" data-mp="26kanytix5a6v">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-5" data-id="element-271" data-mp="22igtj2zbh2f5">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-272" data-mp="22kjrc96pnzuf" />
                <div data-id="element-273" data-mp="r3tp115ers63">
                  <p className="font-bold text-ink" data-id="element-274" data-mp="r54tz4alb5ys">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-275" data-mp="m3xlf30mi2r2">{t.role}</p>
                  <Stars data-id="element-276" data-mp="m6tk4tkaovgk" />
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CtaButton label="I want to train with the Decision Lab™" className="mt-10" data-id="element-277" data-mp="skh00xc9e66a" />
      </div>
    </section>;
}